import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/creative_competency.png'
import _imports_1 from '@/assets/img/structure_step1.png'
import _imports_2 from '@/assets/img/structure_step2.png'
import _imports_3 from '@/assets/img/structure_step3.png'
import _imports_4 from '@/assets/img/structure_step4.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sub_layout_nav dis_desktop" }
const _hoisted_3 = { class: "home" }
const _hoisted_4 = { class: "width_wrap" }
const _hoisted_5 = { class: "sub_menu_01" }
const _hoisted_6 = { class: "snb" }
const _hoisted_7 = { class: "active" }
const _hoisted_8 = { class: "body_content sub" }
const _hoisted_9 = { class: "sub1" }
const _hoisted_10 = { class: "img" }

import { USER_ROUTES } from "@/assets/route_constants.ts";
import Banner from "@/components/Banner.vue";
import { NIcon } from "naive-ui";
import { HomeSharp } from "@vicons/ionicons5";

export default /*@__PURE__*/_defineComponent({
  __name: 'Introduction',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_space = _resolveComponent("n-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "CreateX소개",
      subtitle: "CreateX소개",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(NIcon), null, {
            default: _withCtx(() => [
              _createVNode(_unref(HomeSharp))
            ]),
            _: 1
          })
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"deps1\" data-v-43e0c01c>CreateX소개</div><div class=\"deps2\" data-v-43e0c01c> CreateX 소개 <span class=\"icon-chevron-thin-down on\" data-v-43e0c01c></span><span class=\"icon-chevron-thin-up\" data-v-43e0c01c></span><ul class=\"deps2_nav\" data-v-43e0c01c><li class=\"on\" data-v-43e0c01c><a href=\"sub1_1.html\" alt=\"CreateX 소개\" data-v-43e0c01c>CreateX 소개<i data-v-43e0c01c></i></a></li></ul></div>", 2))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: `${_unref(USER_ROUTES).INTRO}`
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("CreateX 소개")
                ])),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("CreateX 소개"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _cache[7] || (_cache[7] = _createStaticVNode("<div data-v-43e0c01c><h1 data-v-43e0c01c>Createx 란</h1><div class=\"bg\" data-v-43e0c01c><p data-v-43e0c01c><strong data-v-43e0c01c> 역량 진단디자인 시스템의 브랜드 네임으로 Create Experience의 줄임말입니다. <br data-v-43e0c01c><span data-v-43e0c01c>&quot;새로운 · 특별한 · 강력한 · 확실한 미래를 주도할 “경험을 창조하라”</span><br data-v-43e0c01c></strong></p><p data-v-43e0c01c> 이는 성장기 학생이 미래 경쟁력을 갖추기 위해 <br data-v-43e0c01c> 자신의 경험을 재구조화 할 필요가 있음을 의미합니다. </p></div></div><div data-v-43e0c01c><h1 data-v-43e0c01c>목적 및 목표</h1><div class=\"bg\" data-v-43e0c01c><p data-v-43e0c01c><strong data-v-43e0c01c> CreateX는 성장기 학생의 창조 역량을 총체적, 심층적으로 진단, 디자인함으로써,<br data-v-43e0c01c> 미래 경쟁력을 갖추어 창조적 삶을 주도하는 해법을 제시하는 데 목적이 있습니다. </strong></p></div><ul class=\"box\" data-v-43e0c01c><li data-v-43e0c01c> 목표 1. 성장기 학생의 21세기 핵심역량을 진단, 디자인합니다. </li><li data-v-43e0c01c> 목표 2. 성장기 학생의 재능 · 경험 · 지식 창출의 성장 과정을 진단, 디자인합니다. </li><li data-v-43e0c01c> 목표 3. 성장기 학생의 창조적 성취 역량, 잠재 역량, 그리고 그 성장가능성을 진단, 디자인합니다. </li></ul></div><div data-v-43e0c01c><h1 data-v-43e0c01c>특징</h1><div class=\"bg\" data-v-43e0c01c><ul class=\"box1\" data-v-43e0c01c><li data-v-43e0c01c><strong data-v-43e0c01c>나의 <i data-v-43e0c01c>새로운</i> 미래를 진단, 디자인합니다</strong><span data-v-43e0c01c> 새 시대의 꿈, 정신을 배경으로 구축한 미래형 진단시스템입니다<br data-v-43e0c01c> 성장기 학생의 미래를 새로운 패러다임으로 진단, 구조화 합니다 </span><h3 data-v-43e0c01c>01</h3></li><li data-v-43e0c01c><strong data-v-43e0c01c>나의 <i data-v-43e0c01c>특별한</i> 경험을 진단, 디자인합니다</strong><span data-v-43e0c01c> 미래 사회가 가치를 두는 특별한 인식으로 구성되어 있습니다 <br data-v-43e0c01c> 성장기 학생의 마음을 세상과 연결시키는 특별한 경험을 진단, 구조화 합니다 </span><h3 data-v-43e0c01c>02</h3></li><li data-v-43e0c01c><strong data-v-43e0c01c>나의 <i data-v-43e0c01c>강력한</i> 경쟁력을 진단, 디자인합니다</strong><span data-v-43e0c01c> 미래 사회의 혁신에 필요한 지식 창출의 가능성을 진단하는 강력한 툴입니다<br data-v-43e0c01c> 최고 전문가의 가이드, 평가, 컨설팅, 코칭으로 학생의 강력한 경쟁력을 진단, 구조화 합니다 </span><h3 data-v-43e0c01c>03</h3></li><li data-v-43e0c01c><strong data-v-43e0c01c>나의 <i data-v-43e0c01c>확실한</i> 미래를 진단, 디자인합니다 </strong><span data-v-43e0c01c> 대학, 기업, 산업 현장, 교육 현장이 기대하는 인재상을 평가, 관리하는 툴입니다<br data-v-43e0c01c> 진로 선택 및 진학에서 놀라운 경쟁력을 지닌 나의 확실한 미래를 진단, 구조화 합니다 </span><h3 data-v-43e0c01c>04</h3></li></ul></div></div>", 3)),
          _createElementVNode("div", null, [
            _cache[3] || (_cache[3] = _createElementVNode("h1", null, "창조역량모델", -1)),
            _createElementVNode("figure", _hoisted_10, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    style: {"width":"500px"},
                    src: _imports_0
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "info_box" }, [
              _createElementVNode("h3", null, "창조역량모델"),
              _createElementVNode("p", null, " 창조 역량은 타고난 일반지능, 재능, 습득한 지식, 사고, 경험으로 성장합니다. 창조 역량은 개인이 성장기 내내 직면하는 수많은 발달 과업을 해결하는 가운데 지적 활동을 선택, 조직화 하며, 경험을 키우고 최적화 하여 성취를 이끌어냅니다. ")
            ], -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info_box" }, [
              _createElementVNode("h3", null, "모델의 학문적 배경은"),
              _createElementVNode("p", null, " 다윈의 진화론, Whitehead의 세상/지식의 생명체설, Bergson의 창조적 진화론, James의 경험 이론, Prigogine의 자기조직화 이론, Seung의 Connectome 개념, Gruber의 진화시스템모델, Csikszentmihalyi의 창의성시스템모델, Gagné의 개별화재능모델 등 입니다 ")
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "info_box" }, [
              _createElementVNode("h3", null, "모델의 성장 과정은"),
              _createElementVNode("p", null, " 다수 국가과학자의 삶을 토대로 개념모델의 틀을 갖추었고, 한국 최고 교육기관 수십 인 전문가의 아이디어로 이 모델은 성장을 거듭해 왔습니다. 오랜 기간 지속성장해 온 이 모델은 전국 교육 현장의 선발 및 진학에 다양한 형태로 활용되어 왔습니다. 마침내 새 시대의 선포에 즈음하여 이 모델은 새로운 꿈을 품은 창조역량모델로 재구성, 확장되었습니다. ")
            ], -1))
          ]),
          _cache[8] || (_cache[8] = _createStaticVNode("<div data-v-43e0c01c><h1 data-v-43e0c01c>구성</h1><ol data-v-43e0c01c><li data-v-43e0c01c><span data-v-43e0c01c>STEP 01</span><figure data-v-43e0c01c><img style=\"width:100px;\" src=\"" + _imports_1 + "\" data-v-43e0c01c></figure><strong data-v-43e0c01c>예약</strong></li><li data-v-43e0c01c><span data-v-43e0c01c>STEP 02</span><figure data-v-43e0c01c><img style=\"width:100px;\" src=\"" + _imports_2 + "\" data-v-43e0c01c></figure><strong data-v-43e0c01c>진단</strong></li><li data-v-43e0c01c><span data-v-43e0c01c>STEP 03</span><figure data-v-43e0c01c><img style=\"width:96px;\" src=\"" + _imports_3 + "\" data-v-43e0c01c></figure><strong data-v-43e0c01c>상담 코칭</strong></li><li data-v-43e0c01c><span data-v-43e0c01c>STEP 04</span><figure data-v-43e0c01c><img style=\"width:96px;\" src=\"" + _imports_4 + "\" data-v-43e0c01c></figure><strong data-v-43e0c01c>Activity</strong></li></ol></div>", 1))
        ])
      ])
    ])
  ]))
}
}

})